require("@babel/polyfill");
import Vue from 'vue'
import './plugins/vuetify'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import vuelidate from 'vuelidate'
import './styles/main.scss'
import './styles/main.scss'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Siema from 'v-siema'

Vue.use(Siema);
axios.defaults.baseURL = 'https://clientes.lacentral.com.co/services/';
// = 'https://clsrv1.aliatec.co:81/servicios/';
//axios.defaults.baseURL = 'http://localhost:52429/';
//axios.defaults.baseURL = 'http://192.168.1.69:52429/';
//axios.defaults.baseURL = 'https://www.pppqr.com:8080/';
//axios.defaults.baseURL = 'https://localhost:44370/';
Vue.use(vuelidate)

sync(store, router)

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})